/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{TechniqueType as e}from"../TechniqueType.js";import{AnimatedMarkerShader as r}from"./AnimatedMarkerShader.js";import{AnimatedTechnique as t}from"./AnimatedTechnique.js";class s extends t{constructor(){super(...arguments),this.type=e.AnimatedMarker,this.shaders={geometry:new r}}}export{s as AnimatedMarkerTechnique};
